// sapi-admin/src/utils/notificationHelper.js
import { getMessaging } from 'firebase/messaging';
import { doc, collection, getDocs, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Envoie une notification push à un utilisateur
 * @param {string} userId - ID de l'utilisateur
 * @param {Object} payload - { notification: { title, body }, data: {} }
 * @returns {Promise<number>} - Nombre de notifications envoyées
 */
export const sendAndCleanTokens = async (userId, payload) => {
  try {
    if (!userId) {
      console.warn('⚠️ sendAndCleanTokens: userId is required');
      return 0;
    }

    // Récupérer les tokens FCM de l'utilisateur
    const tokensSnapshot = await getDocs(collection(db, 'users', userId, 'fcmTokens'));
    if (tokensSnapshot.empty) {
      console.log(`ℹ️ No FCM tokens found for user ${userId}`);
      return 0;
    }
    
    const tokens = tokensSnapshot.docs.map(d => d.id);
    console.log(`📤 Sending push to ${tokens.length} devices for user ${userId}`);
    
    const messaging = getMessaging();
    
    // Envoyer la notification
    const response = await messaging.sendEachForMulticast({
      tokens,
      notification: payload.notification,
      data: payload.data || {}
    });
    
    // Nettoyer les tokens invalides
    const deletePromises = [];
    response.responses.forEach((resp, idx) => {
      if (!resp.success && resp.error?.code === 'messaging/registration-token-not-registered') {
        console.log(`🗑️ Removing invalid token: ${tokens[idx].substring(0, 10)}...`);
        deletePromises.push(
          deleteDoc(doc(db, 'users', userId, 'fcmTokens', tokens[idx]))
        );
      }
    });
    await Promise.all(deletePromises);
    
    console.log(`✅ Push sent to ${response.successCount} devices`);
    return response.successCount;
  } catch (error) {
    console.error('❌ sendAndCleanTokens error:', error);
    return 0;
  }
};

/**
 * Envoie une notification à un admin
 * @param {string} adminId - ID de l'admin
 * @param {Object} payload - { title, body, data }
 */
export const sendAdminNotification = async (adminId, payload) => {
  return sendAndCleanTokens(adminId, {
    notification: { title: payload.title, body: payload.body },
    data: payload.data || {}
  });
};